export default __webpack_public_path__ + "assets/images/5bce945220a22cfcc0f1bc7c76a911d7.svg";